import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsMicFill } from 'react-icons/bs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showSuccessToast, showErrorToast } from '../../utils/toastUtils';
import { fetchProfile } from '../../Services/profile/profileservice';
import { Mic } from 'lucide-react';

const VoiceControl = ({text,AddClass}) => {
  const [isListening, setIsListening] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [profile,setProfile] = useState({});
  const [currentItem, setCurrentItem] = useState('');
  const recognitionRef = useRef(null);
  const navigate = useNavigate();


  useEffect(() => {
    if (!showModal) return;
    let i = 0;
    const interval = setInterval(() => {
      setCurrentItem(menuItems[i]);
      i = (i + 1) % menuItems.length;
    }, 600);
  
    return () => clearInterval(interval);
  }, [showModal]);
  

   useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const profileData = await fetchProfile();
                setProfile(profileData.data);
            } catch (error) {
                console.error('Error fetching profile:', error);
            }
        };

        fetchProfileData();
    }, []);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      toast.error("Speech Recognition not supported in this browser.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onstart = () => {
      setShowModal(true);
    };

    recognition.onresult = (event) => {
      const command = event.results[0][0].transcript.trim().toLowerCase();
      handleVoiceCommand(command);
    };

    recognition.onerror = (event) => {
      showErrorToast(`Recognition error: ${event.error}`);
      stopListening();
    };

    recognition.onend = () => {
      stopListening();
    };

    recognitionRef.current = recognition;
  }, []);

  const startListening = () => {
    if (recognitionRef.current) {
      setIsListening(true);
      setShowModal(true);
      recognitionRef.current.start();
    }
  };



  const stopListening = () => {
    setIsListening(false);
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    // Delay hiding the modal by 3 seconds (3000 ms)
    setTimeout(() => {
      setShowModal(false);
    }, 5000); // You can increase this to 5000 (5 sec) or more
  };
  

  const handleVoiceCommand = (command) => {
    const routes = [
      { keywords: ['dashboard'], path: '/Dashboard' },
      { keywords: ['profile'], path: '/ProfileApiUser' },
      { keywords: ['add fund'], path: '/AddFund' },
      { keywords: ['equifax'], path: '/EquifaxCrScore' },
      { keywords: ['highmark'], path: '/HighmarkCrScore' },
      { keywords: ['credit report'], path: '/EquifaxReport' },
      { keywords: ['developer api'], path: '/ServicePage' },
      { keywords: ['whitelist ip'], path: '/WhitelistIp' },
      { keywords: ['whitelist bank'], path: '/WhitelistYourBankAc' },
      { keywords: ['wallet'], path: '/BusinessWalletStructure' },
      { keywords: ['commission and charges'], path: '/CommissionCharges' },
      { keywords: ['test aadhar'], path: '/TestAadhar' },
      { keywords: ['test pan'], path: '/TestPan' },
      { keywords: ['test bank penny'], path: '/BankPennyTest' },
      { keywords: ['test gst'], path: '/VerifyGST' },
      { keywords: ['test mobile'], path: '/MobileToBank' },
      { keywords: ['test rc'], path: '/RCVerify' },
      { keywords: ['test dl'], path: '/DLVerify' },
      { keywords: ['test aadhar pan'], path: '/AadharPanLink' },
      { keywords: ['aadhar download'], path: '/aadhar/download' },
      { keywords: ['itr download'], path: '/' },
      { keywords: ['test cin'], path: '/company-cin/verification' },
      { keywords: ['test ration'], path: '/verify/ration-card' },
      { keywords: ['itr compliance'], path: '/itr/compliance-check' },
      { keywords: ['simple upi'], path: '/upi-verification/simple' },
      { keywords: ['advance upi'], path: '/upi-verification/advance' },
      { keywords: ['bank analysis'], path: '/bank-statement/analysis' },
      { keywords: ['transunion'], path: '/credit-report/transunion' },
      { keywords: ['V2 score'], path: '/credit-report/equifax-v2' },
      { keywords: ['experian'], path: '/credit-report/experian' },
      { keywords: ['lock'], path: '/LockScreen' },
      { keywords: ['test master'], path: '/TestMaster' },
    ];

    const match = routes.find(route => route.keywords.some(k => command.includes(k)));

    if (match) {
      navigate(match.path);
      showSuccessToast(`Navigating to ${match.path}`);
    } else {
      toast.error("Command not recognized.", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        draggable: true,
        pauseOnHover: true
      });
    }
  };

  
  const menuItems = [
    "Dashboard", "Profile", "Lock",
    "Add Fund", "Wallet Statement", "Whitelist IP", "Whitelist Bank",
    "Equifax Score", "Experian Score", "Transunion Score", "Credit Report",
    "Test Aadhar", "Test Pan", "Test Bank Penny", "Test GST", "Test Mobile", "Test RC", "Test DL", "Test Aadhar Pan", "Test CIN", "Test Ration",
    "Simple UPI", "Advance UPI",
    "Aadhar Download", "ITR Download", "ITR Compliance",
    "Bank Analysis",
    "Developer API", "Commission and Charges", "Test Master"
  ];

  return (
<>
  <button
    className={`flex  ${AddClass} items-center justify-center  md:py-0 p-0 rounded-md  gap-0 md:gap-2 font-medium cursor-pointer transition
      ${isListening 
        ? 'bg-green-600 text-white hover:text-white hover:bg-purple-700 hover:border-blue-700' 
        : ' text-black hover:text-white hover:bg-purple-700 hover:border-blue-700'}`}
    onClick={isListening ? stopListening : startListening}
  >
    <Mic size={24} className="text-white font-bold " />
    <span className="ml-0 font-semibold">{text}</span>
    {isListening && <span className="ml-1">Listening..... </span>}
  </button>

  {showModal && (
    <div className="fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl px-8 py-6 max-w-md w-full flex flex-col items-center relative">
        <div className="flex items-center gap-2 mb-4 bg-slate-600">
          <span className="w-4 h-4 rounded-full bg-blue-500 animate-pulse" />
          <span className="w-4 h-4 rounded-full bg-red-500 animate-ping" />
          <span className="w-4 h-4 rounded-full bg-yellow-500 animate-pulse" />
          <span className="w-4 h-4 rounded-full bg-green-500 animate-ping" />
          <span className="w-4 h-4 rounded-full bg-cyan-500 animate-pulse" />
          <span className="w-4 h-4 rounded-full bg-pink-500 animate-pulse" />
          <span className="w-4 h-4 rounded-full bg-lime-500 animate-ping" />
        </div>

        <p className="text-lg font-medium text-gray-700 text-center">
          Listening... <br />
          {profile?.name} Speak your command: <br />
          <span className="text-blue-600 font-bold">{currentItem}</span>
        </p>

        <button
          aria-label="Close listening modal"
          className="absolute top-2 right-3 text-gray-400 hover:text-red-500 text-2xl font-bold"
          onClick={stopListening}
        >
          &times;
        </button>
      </div>
    </div>
  )}
</>

  );
};

export default VoiceControl;
